import * as React from 'react';
import * as classNames from 'classnames';
import {L} from '../../../../lang';
if (process.env.BROWSER) {
    require('./index.less');
}
export interface ICommentHeaderProp {// props
    userImage: string;
    userName: string;
    publishTime: number;
    isWemediaUser?: boolean;
    isWemediaAuthor?: boolean;
}
export default class CommentHeader extends React.PureComponent<ICommentHeaderProp> {
    public render(): JSX.Element {
        const isWemediaUser = this.props.isWemediaUser || false;
        const isWemediaAuthor = this.props.isWemediaAuthor || false;
        const userName = this.props.userName;
        return <div className={'comment-item-header'}>
            <div className={'comment-item-avatar'} >
                <img className={classNames({
                    'comment-item-userimage': true,
                    'comment-wemedia-user': isWemediaUser,
                })}
                    src={this.props.userImage || 'http://img.ucweb.com/s/uae/g/3k/public/c/widget/comment-list/img/avator_aa09ffb.png'} />
            </div>

            <div className={
                classNames({
                    'comment-item-username': true,
                    'comment-wemedia-user': isWemediaUser,
                    'comment-wemedia-author': isWemediaAuthor,
                })
            }  >
                <span className={'comment-item-username-text'} >{userName}</span>
                <span className={'comment-item-username-time'} >
                    {this.formatTime(this.props.publishTime, L('default.justnow'))}
                </span>
            </div>
        </div>;
    }

    private formatTime(time: number, justnow?: string): string {
        const nowTime = Date.now();
        const timeSpan = (nowTime - time) / 1000;
        let renderText = '';
        if (timeSpan < 60) {
            renderText = justnow || 'justnow';
        } else if (timeSpan < 3600) {
            renderText = Math.floor(timeSpan / 60) + ' m'; // 精简时间格式
        } else if (timeSpan < 24 * 3600) {
            renderText = Math.floor(timeSpan / 3600) + ' h'; // 精简时间格式
        } else {
            const originalTime = new Date(time);
            const month = originalTime.getMonth() + 1;
            const day = originalTime.getDate();
            const hour = originalTime.getHours();
            const minute = originalTime.getMinutes();
            const monthStr = `${month < 10 ? '0' : ''}${month}`;
            const dayStr = `${day < 10 ? '0' : ''}${day}`;
            const hourStr = `${hour < 10 ? '0' : ''}${hour}`;
            const minuteStr = `${minute < 10 ? '0' : ''}${minute}`;
            renderText = monthStr + '-' + dayStr + ' ' + [hourStr, minuteStr].join(':'); // 精简时间格式
        }

        return renderText;

    }
}
